<template>
  <div 
  class="moow-master-container play-background" 
  v-loading.fullscreen="loading" element-loading-text="Saving Data ..." element-loading-spinner="el-icon-loading">
    <nav-basic :progress="80" title=""></nav-basic>
    <div class="container">
      <b-row class="step-header">
        <p class="moow-header">Setting the price</p>
      </b-row>
      <b-row>
        <b-col>
          <listing-pricing ref="pricingReference"
            :selectedM2Price = "m2PriceComputed"
            :selectedPriceDaily="selectedPriceDaily"
            :selectedPriceMonthly="selectedPriceMonthly"
            :selectedEssentialFees="selectedEssentialFees"
            :selectedCleaningFees="selectedCleaningFees"
            :selectedDepositDaily="selectedDepositDaily"
            :selectedWeeklyDiscount="selectedWeeklyDiscount"
            :selectedDepositMonthly="selectedDepositMonthly"
            :selectedUtilityFees="selectedUtilityFees"
            :selectedMediumPeriodDiscount="selectedMediumPeriodDiscount"
            :selectedLongPeriodDiscount="selectedLongPeriodDiscount">
          </listing-pricing>


          <b-row class="step-navigator-buttons">
            <b-col style="text-align:left;padding:0">
              <md-button @click="prev()" class="md-primary">
                <md-icon>arrow_back</md-icon>Back
              </md-button>
            </b-col>
            <b-col style="text-align:right;padding:0">
              <md-button @click="next" class="md-primary play-cta-button makeup">Next</md-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="5" offset-md="1">
          <md-card>
            <md-card-header>
              <div class="md-title">Moowle's Auto Price</div>
            </md-card-header>

            <md-card-content>
               <auto-price-prediction
               :property="currentListing"/>
            </md-card-content>
          </md-card>
        </b-col>


      </b-row>
    </div>

    <error-snackbar
      :message="snackbarMessage"
      :duration="Number(4000)"
      :showSnackbar="showSnackbar"
      position="center"
      :isInfinity="false">
    </error-snackbar>
  </div>

</template>

<script>
  import Pricing from '../components/listingComponents/listingPrices.vue';
  import AutoPricePrediction from '../components/pricing/autoPricePrediction.vue'
  import {
    updateListingParts
  } from '../listingFunctions.js'
  // import {
  //   currencyList,
  //   ownershipTypeList,
  //   limitationList
  // } from '../lists.js';
  const lists = require("@/lists.js");

  import Snackbar from './snackbar.vue'
  import { buildRentPricingPredictionRequest } from '../pricing/factory/pricingFactory.js'
  export default {
    name: 'price1',
    components: {
        'listing-pricing': Pricing,
        'error-snackbar': Snackbar,
        'auto-price-prediction': AutoPricePrediction
    },
    data() {
      return {
        showSnackbar: false,
        snackbarMessage:"",
        selectedPriceDaily: undefined,
        selectedPriceMonthly:undefined,
        selectedEssentialFees: undefined,
        selectedCleaningFees: undefined,
        selectedDepositDaily: undefined,
        selectedWeeklyDiscount: undefined,
        selectedDepositMonthly: undefined,
        selectedMediumPeriodDiscount: undefined,
        selectedLongPeriodDiscount: undefined,
        selectedUtilityFees:[],
        loading: false,
        limitations: lists.limitationList,
        ownerships: lists.ownershipTypeList,
        currencies: lists.currencyList,
        ownership: '',
        limitation: '',
        currency: '',
        priceIncludes: [],
        monthly: true,
        daily: true,
        rent: false,
        m2Price: undefined,
        bargPrice: undefined,
        price: undefined,
        addFees: '',
        addDesc: '',
        deposit: undefined,
        pricePlaceholder: '€',
        loadingPricePrediction:true,
        pricePredictionResponse:"",
        pricePredictionErr:"",
        pricePrediction:""
      }
    },
    created() {
      this.txnDet.txnType == 'rent'
      this.txnDet.currency == 'eur'
      // PRICING
      this.selectedPriceDaily = this.txnDet.priceDaily
      this.selectedPriceMonthly = this.txnDet.priceMonthly
      this.selectedEssentialFees = this.txnDet.essentialsFee
      this.selectedCleaningFees = this.txnDet.cleaningFees
      this.selectedDepositDaily = this.txnDet.depositDaily
      this.selectedWeeklyDiscount = this.txnDet.weeklyDiscount
      this.selectedDepositMonthly = this.txnDet.depositMonthly
      this.selectedUtilityFees = this.txnDet.ADDUtiltyFees
      this.selectedMediumPeriodDiscount = this.txnDet.mediumPeriodDiscount
      this.selectedLongPeriodDiscount = this.txnDet.longPeriodDiscount
      this.getPricePrediction()
    },
    computed: {
      rentPricePrediction(){
        return this.$store.getters.rentPricePrediction
      },
      currentListing(){
        return this.$store.getters.listing
      },
      txnDet() {
        return this.$store.getters.txnDet
      },
      availDet() {
        return this.$store.getters.availDet
      },
      m2PriceComputed(){
        try{
          return (this.selectedPriceMonthly / this.$store.getters.techDet.generalArea).toFixed(2)
        }catch(err){
          return 0
        }
      },
    },
    methods: {
      getMaxSimilarProperties(pricePrediction, maxNr){
        if(pricePrediction && pricePrediction.similarProperties) return pricePrediction.similarProperties.slice(0, maxNr);
        return ""
      },
      getRentPriceMonthly(pricePrediction){
          const predictionValue = parseFloat(pricePrediction.price)
          const delta = predictionValue * 5 /100
          var res = ""
          var min = predictionValue - delta
          var max = predictionValue + delta
          return min.toFixed(0) + " - " + max.toFixed(0)
      },
      getPricePrediction(){
        const requestBuilder = buildRentPricingPredictionRequest(this.currentListing)
        if(requestBuilder.success){
          this.$store.dispatch("setRentPricePrediction", requestBuilder.result)
        }else{
          this.$store.commit("SET_RENT_PRICE_PREDICTION", {err:"Cannot predict price"})
        }
      },
      next() {
        this.saveLocally()  //to load the form variable into store
        this.$validator.validateAll().then((result) => {
          if (result && this.validateCustomPreSaveFields()) {
            if(!this.txnDet.priceMonthly && !this.txnDet.priceDaily){
              this.$dialog.confirm('Continue without pricing?')
                .then(() => {
                  this.save()
                  this.leavePage('PRICE1', 'price2')
                })
                .catch(function (err) {
                });
            }else{
              this.save()
              this.leavePage('PRICE1', 'price2')
            }
          } else {
            this.$notify({
              title: 'Review fields',
              message: 'Fields missing of faulty'
            })
          }
        })
      },
      prev() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.saveLocally()
            this.leavePage('PRICE1', 'addListing1')
          } else {
            this.$notify({
              title: 'Notification',
              message: 'Please fix the error'
            })
          }
        })
      },
      saveAndExit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
            this.leavePage('SCENE2', 'dashboard')
          } else {
            this.notifyError('Notification', 'Something is missing')
          }
        })
      },
      saveLocally(){
        this.txnDet.txnType = 'rent'
        this.setListingPricesToStore()
        this.$store.commit('UPDATE_TXNDET', this.txnDet)
        this.$store.commit('UPDATE_AVAILDET', this.availDet)
      },
      save(){
        this.saveLocally()
        updateListingParts(this.createUpdateParts()).catch(err => {})
      },
      createUpdateParts(){
        return{
          'txnDet': this.txnDet,
          'availDet': this.availDet
        }
      },
      setListingPricesToStore(){
        // PRICING
        this.txnDet.priceDaily = this.$refs.pricingReference.getPriceDaily()
        this.txnDet.priceMonthly = this.$refs.pricingReference.getPriceMonthly()
        this.txnDet.essentialsFee = this.$refs.pricingReference.getEssentialFees()
        this.txnDet.cleaningFees = this.$refs.pricingReference.getCleaningFees()
        this.txnDet.depositDaily = this.$refs.pricingReference.getDepositDaily()
        this.txnDet.weeklyDiscount = this.$refs.pricingReference.getWeeklyDiscount()
        this.txnDet.depositMonthly = this.$refs.pricingReference.getDepositMonthly()
        this.txnDet.ADDUtiltyFees = this.$refs.pricingReference.getUtilityFees()
        this.txnDet.mediumPeriodDiscount = this.$refs.pricingReference.getMediumPeriodDiscount()
        this.txnDet.longPeriodDiscount =  this.$refs.pricingReference.getLongPeriodDiscount()
      },
      validateCustomPreSaveFields(){
        var validated = true
        this.$refs.pricingReference.getPriceDaily()<0?validated=false:void 0;
        this.$refs.pricingReference.getPriceMonthly()<0?validated=false:void 0;
        this.$refs.pricingReference.getEssentialFees()<0?validated=false:void 0;
        this.$refs.pricingReference.getCleaningFees()<0?validated=false:void 0;
        this.$refs.pricingReference.getDepositDaily()<0?validated=false:void 0;
        this.$refs.pricingReference.getWeeklyDiscount()<0?validated=false:void 0;
        this.$refs.pricingReference.getDepositMonthly()<0?validated=false:void 0;
        this.$refs.pricingReference.getUtilityFees()<0?validated=false:void 0;
        this.$refs.pricingReference.getMediumPeriodDiscount()<0?validated=false:void 0;
        this.$refs.pricingReference.getLongPeriodDiscount()<0?validated=false:void 0;

        if(validated) return true
        else{
          this.showSnackbar=true
          this.snackbarMessage="Price values cannot be negative"
        }
      },
      leavePage(from, to){
        this.$store.dispatch('visitPage', from);
        this.$router.push({
          name: to
        })
      },
    },
    watch: {
      txnDet: {
        deep: true,
        handler: function (val) {
          if (this.txnDet.currency == 'usd') this.pricePlaceholder = '$'
          else if (this.txnDet.currency == 'eur') this.pricePlaceholder = '€'
          else this.pricePlaceholder = '£'
          if(this.txnDet.priceMonthly && this.txnDet.priceMonthly > 0 && this.$store.getters.techDet.generalArea) this.txnDet.m2Price = parseFloat((this.txnDet.priceMonthly / this.$store.getters.techDet.generalArea).toFixed(2))
          else this.txnDet.m2Price = 0.00
        }
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../assets/styles/global.css";

  .price-est-value{
    font-size: 22px;
    font-weight: 400;
    color: #fc5226;
  }

  #desc {
    background-color: #fafafa;
  }

  .checkBtn {
    opacity: 0;
    outline: none;
    position: absolute;
    margin: 0;
    left: -999px;
  }

  p {
    color: #757575;
    text-align: left;
    font-size: 14px;
  }

  .row {
    margin-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/price1.vue